var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInfomaticaPasivo200X70(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 70,
    viewBox: "0 0 200 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12788 38.1424H4.07812V58.4688H9.12788V38.1424Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3689 49.5907L16.5685 38.1424H12.7131V58.4688H17.7629V47.3176L27.5035 58.4688H31.4187V38.1424H26.3689V49.5907Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.668 58.4688H39.7177V51.2945H48.4434V46.9008H39.7177V42.5959H49.8172V38.1424H34.668V58.4688Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6716 37.7236C56.5451 37.7236 51.9141 42.3855 51.9141 48.3055C51.9141 54.2255 56.5451 58.8855 62.6716 58.8855C68.798 58.8855 73.458 54.2236 73.458 48.3055C73.458 42.3875 68.8251 37.7236 62.6716 37.7236ZM62.6716 54.1927C59.3835 54.1927 57.0236 51.5029 57.0236 48.3055C57.0236 45.1082 59.3835 42.4164 62.6716 42.4164C65.9596 42.4164 68.3195 45.1063 68.3195 48.3055C68.3195 51.5048 65.9596 54.1927 62.6716 54.1927Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5011 48.9925L80.2709 38.1423H76.5352V58.4687H81.5849L81.556 48.2148L86.0982 55.2386V55.2694H88.9058V55.2386L93.4172 48.2746V58.4687H98.4689V38.1423H94.7042L87.5011 48.9925Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.568 36.7666L109.128 39.881L108.277 41.8839L115.062 38.0054L114.568 36.7666Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.408 58.4687H106.786L108.131 54.9703H116.735L118.109 58.4687H123.458L115.205 38.8621L107.878 43.1419L101.406 58.4687H101.408ZM109.804 50.6673L112.434 43.9118L115.064 50.6673H109.806H109.804Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.744 42.6557H130.228V58.4688H135.277V42.6557H141.732V38.1424H123.744V42.6557Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.261 38.1423H144.211V58.4687H149.261V38.1423Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.094 42.4473C165.782 42.4473 167.576 44.0315 168.144 46.5708H173.313C172.686 41.3088 168.682 37.7236 163.123 37.7236C156.998 37.7236 152.365 42.1771 152.365 48.3055C152.365 54.4339 156.998 58.8855 163.123 58.8855C168.682 58.8855 172.686 55.2984 173.313 50.0383H168.144C167.576 52.5796 165.782 54.1638 163.094 54.1638C159.777 54.1638 157.477 51.6823 157.477 48.3055C157.477 44.9287 159.777 42.4473 163.094 42.4473Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.432 38.0228H183.621L174.986 58.4688H180.366L181.711 54.9704H190.317L191.691 58.4688H197.04L188.434 38.0228H188.432ZM183.382 50.6655L186.012 43.91L188.642 50.6655H183.384H183.382Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.089 28.0178C99.6661 28.0178 99.257 27.7978 99.0312 27.408C98.6935 26.8234 98.8942 26.0766 99.477 25.7409L143.688 0.164039C144.273 -0.173641 145.017 0.0270373 145.355 0.609776C145.691 1.19251 145.492 1.93927 144.909 2.27695L100.698 27.8538C100.507 27.9638 100.297 28.0178 100.091 28.0178H100.089Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0624 27.9793C79.6398 27.9793 79.2307 27.7593 79.005 27.3695C78.6692 26.7849 78.868 26.0381 79.4507 25.7024L112.599 6.52024C113.184 6.18256 113.929 6.38324 114.266 6.96598C114.604 7.55064 114.403 8.2974 113.821 8.63315L80.6722 27.8153C80.4792 27.9253 80.2708 27.9793 80.0624 27.9793Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 27.9792C59.5734 27.9792 59.1682 27.7631 58.9444 27.3752C58.6125 26.7983 58.8093 26.0592 59.3863 25.7274L81.6693 12.8589C82.2462 12.5251 82.9833 12.7219 83.3171 13.3008C83.651 13.8777 83.4541 14.6148 82.8753 14.9486L60.5942 27.8171C60.4051 27.9271 60.1967 27.9792 59.9922 27.9792H59.9902Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_2443",
    x1: 98.8672,
    y1: 14.0089,
    x2: 145.519,
    y2: 14.0089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#40BD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3DAA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#398BC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3677DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_137_2443",
    x1: 78.8429,
    y1: 17.1678,
    x2: 114.43,
    y2: 17.1678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#40BD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3DAA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#398BC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3677DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_137_2443",
    x1: 58.7823,
    y1: 20.338,
    x2: 83.4773,
    y2: 20.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42C57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#40BD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3DAA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#398BC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3677DE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfomaticaPasivo200X70);
export default __webpack_public_path__ + "static/media/LOGO_INFOMATICA_PASIVO_200X70.459063270f0b1c37d211887807fd4379.svg";
export { ForwardRef as ReactComponent };